import { joinParts } from './utils'

export const performer = {
  details: (id: string) => joinParts('performers', id),
  events: (id: string) => joinParts('performers', id, 'events'),
  seasons: (id: string) => joinParts('performers', id, 'typeTicketCollections'),
  metadata: (id: string) => joinParts('performers', id, 'meta'),
}
